<template>
  <div id="app">
    <Header :kinofinder="true" />
    <mq-layout mq="lg+">
      <Top />
      <Cites />
      <Smalltext />
      <Inhalt />
      <Gallerie />
      <Team />
    </mq-layout>
    <mq-layout :mq="['sm', 'md']">
      <Mobile />
    </mq-layout>
    <BasePicture border="white" image="allgemein/pic01.jpg" />
    <Footer />
    <BaseYoutube :youtube="$config.youtube" :margin="100" />
  </div>
</template>

<script>
import Header from './website_elements/Header.vue'
import Top from './website_elements/Top.vue'
import Cites from './website_elements/Cites.vue'
import Smalltext from './website_elements/Text.vue'
import Inhalt from './website_elements/Inhalt.vue'
import Gallerie from './website_elements/Gallerie.vue'
import Team from './website_elements/Team.vue'
import Mobile from './website_elements/Mobile.vue'
import Footer from './website_elements/Footer.vue'
import moment from 'moment'

export default {
  name: 'App',
  components: {
    Header,
    Top,
    Cites,
    Smalltext,
    Inhalt,
    Footer,
    Gallerie,
    Team,
    Mobile,
  },
  /**
   * Provide the date in other components
   *
   * to get it in a component: inject: ['kinostart'],
   * see: BaseKinostart.vue
   */
  provide() {
    return {
      kinostart: this.kinostart,
    }
  },
  computed: {
    kinostart() {
      return moment() < moment(this.$config.release_line_1.date)
        ? this.$config.release_line_1.line_before
        : this.$config.release_line_1.line_after
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch('Window/docElem', {
        tmp: window.document.documentElement,
      })
      window.addEventListener('resize', this.sendDispatch)
      this.$store.dispatch('Window/resize')
    })
  },
  methods: {
    sendDispatch() {
      this.$store.dispatch('Window/resize')
    },
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.$config.title,
      // all titles will be injected into this template
      titleTemplate: '%s | Offizielle Webseite',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$config.facebook.og_description,
        },
        {
          vmid: 'og:title',
          name: 'og:title',
          content: this.$config.title,
        },
        {
          vmid: 'og:description',
          name: 'og:description',
          content: this.$config.facebook.og_description,
        },
        {
          vmid: 'og:url',
          name: 'og:url',
          content: this.$config.url,
        },
        {
          vmid: 'og:type',
          name: 'og:type',
          content: 'website',
        },
        {
          vmid: 'og:image',
          name: 'og:image',
          content: `${this.$config.url}/${this.$config.facebook.og_image}`,
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$config.keywords,
        },
        {
          vmid: 'page-topic',
          name: 'page-topic',
          content: 'Medien',
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: 'index, follow',
        },
        {
          vmid: 'author',
          name: 'author',
          content: this.$config.verantwortlich,
        },
        {
          vmid: 'publisher',
          name: 'publisher',
          content: this.$config.verantwortlich,
        },
        {
          vmid: 'copyright',
          name: 'copyright',
          content: this.$config.verantwortlich,
        },
      ],
      link: [{ rel: 'icon', href: this.$config.favicon }],
    }
  },
}
</script>

<style lang="scss">
#app {
  margin-inline: auto;
  max-width: 2560px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
